var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.372,
    height: 25.511,
    viewBox: "0 0 15.372 25.511",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12190",
    "data-name": "Group 12190",
    transform: "translate(15.372 25.511) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6793",
    "data-name": "Group 6793",
    transform: "translate(0 25.511) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5312",
    "data-name": "Path 5312",
    d: "M12.756,15.372a2.608,2.608,0,0,1-1.85-.766L.766,4.466a2.616,2.616,0,1,1,3.7-3.7l8.289,8.289L21.045.766a2.616,2.616,0,0,1,3.7,3.7L14.606,14.606A2.608,2.608,0,0,1,12.756,15.372Z",
    transform: "translate(0 0)",
    fill: "#394f65"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.73e821ea5d4fbcdea0b6de9469e03dd7.svg";
export { ForwardRef as ReactComponent };